export const fieldActArr = {
    // "title": "Field Activity",
    // "logoPosition": "right",
    "pages": [
        {
            "name": "page1",
            "elements": [
                {
                    "type": "dropdown",
                    "name": "selectDealer",
                    "title": "Select dealer",
                    "isRequired": true,
                    "choices": [
                        // "Item 1",
                        // "Item 2",
                        // "Item 3"
                    ]
                },
                // {
                //     "type": "dropdown",
                //     "name": "trialType",
                //     "title": "Type of trials",
                //     "isRequired": true,
                //     "choices": [
                //         "Trial 1",
                //         "Trial 2",
                //         "Trial 3"
                //     ]
                // },
                {
                    "type": "dropdown",
                    "name": "cropType",
                    "title": "Crop type",
                    "isRequired": true,
                    "choices": [
                        "Cereals",
                        "Oilseeds",
                        "Fibre And Oilseed",
                        "Tuber Crops",
                        "Spice Crops",
                        "Vegetables",
                        "Floriculture",
                        "Horticulture",
                        "Plantation"
                    ]
                },
                {
                    "type": "dropdown",
                    "name": "cropName",
                    "title": "Crop name",
                    "isRequired": true,
                    "choices": []
                },
                {
                    "type": "text",
                    "name": "fieldDayDate",
                    "title": "Date of field day",
                    "isRequired": true,
                    "inputType": "date"
                },
                {
                    "type": "text",
                    "name": "numberOfFarmersPresent",
                    "title": "Number of farmers present",
                    "isRequired": true,
                    "inputType": "number",
                    "placeholder": "Enter"
                },
                {
                    "type": "text",
                    "name": "villageName",
                    "title": "Village",
                    "isRequired": true,
                    "placeholder": "Enter"
                },
                {
                    "type": "dropdown",
                    "name": "stateName",
                    "title": "State",
                    "isRequired": true,
                    "choices": [
                        //  "Item 1",
                        //  "Item 2",
                        //  "Item 3"
                    ],
                },
                {
                    "type": "dropdown",
                    "name": "districtName",
                    "title": "District",
                    "isRequired": true,
                    "choices": [
                        //  "Item 1",
                        //  "Item 2",
                        //  "Item 3"
                    ],
                },
                {
                    "type": "text",
                    "name": "meetingLocation",
                    "title": "Meeting location",
                    "isRequired": true,
                    "inputType": "text",
                    "placeholder": "Enter"
                },
                {
                    "type": "file",
                    "name": "fieldDayImage",
                    "title": "Field Day Image",
                    "isRequired": true,
                    "allowMultiple": true,
                    "acceptedTypes": "image/*"
                }
            ]
        }
    ],
    // "navigateToUrl": "https://stag-dms.agrocel.net/#/agrocel/dashboard",
    // "navigateToUrlOnCondition": [
    //     {}
    // ],
    "completeText": "Submit"
}   